import type { ApprovalOverrideScope } from '../../../contracts/harness.types';

const OVERRIDE_SCOPES: readonly ApprovalOverrideScope[] = ['once', 'session'];

const isOverrideScope = (value: unknown): value is ApprovalOverrideScope =>
  OVERRIDE_SCOPES.includes(value as ApprovalOverrideScope);

/** Validate the untyped `available_override_scopes` from a live SSE payload. */
export const parseApprovalOverrideScopes = (
  raw: unknown
): ApprovalOverrideScope[] | undefined => {
  if (!Array.isArray(raw)) return undefined;
  const scopes = raw.filter(isOverrideScope);
  return scopes.length > 0 ? scopes : undefined;
};
